import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
    name: 'MaskNumber'
  })
  export class MaskComponent {
    public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  }
